module.exports = __webpack_public_path__ + "img/looking-glass.2ea2ec07.svg";